<div class="second-step-container">
  <h2>Tell us your work preferences, availability, and desired salary.</h2>

  <!-- Desired Monthly Salary Card -->
  <div class="forms" [formGroup]="form">
    <div class="card-header">
      <h3>What's your desired monthly salary?</h3>
      <span class="pro-tip" 
        nz-popover 
        [nzPopoverContent]="proTipContent" 
        nzPopoverPlacement="bottomRight"
        nzPopoverTrigger="click">
        Pro Tip <i class="fa fa-info-circle"></i>
      </span>
      <ng-template #proTipContent>
        <div class="pro-tip-popover">
          <div class="tip-item">
            <i class="fa fa-check-circle tip-icon green"></i>
            <span>Being flexible can help you match with more roles</span>
          </div>
          <div class="tip-item">
            <i class="fa fa-lock tip-icon yellow"></i>
            <span>We'll never share this with companies.</span>
          </div>
          <div class="tip-item">
            <i class="fa fa-lightbulb tip-icon pink"></i>
            <span>Not sure yet? A lower range keeps more options open</span>
          </div>
        </div>
      </ng-template>
    </div>
    <div class="nz-block-input salary-compact">
      <nz-space-compact class="salary-input-compact">
        <nz-select nzShowSearch class="currency-select" nzPlaceHolder="PHP" formControlName="currency">
          @for (currency of currencyOptions; track currency) {
            <nz-option [nzLabel]="currency" [nzValue]="currency" />
          }
        </nz-select>
        <input nz-input type="text" placeholder="e.g., 20,000" formControlName="desiredSalary" (keyup)="onSalaryChanged($any($event.target).value)" />
      </nz-space-compact>
    </div>
    <div class="flexible-checkbox">
      <label for="" nz-checkbox formControlName="isFlexibleSalary">I'm flexible with my salary.</label>
    </div>
  </div>

  <!-- Work Setup Card -->
  <div class="forms" [formGroup]="form">
    <h3>What kind of work setup works best for you?</h3>
    <div class="nz-block-input" [ngClass]="{error:form.controls['workSetup'].status === 'INVALID' && form.controls['workSetup'].touched}">
      <nz-select nzAllowClear nzPlaceHolder="Select your preferred work setup" formControlName="workSetup">
         @for (workSetup of preferredWorkSetups; track workSetup; ) {
          <nz-option [nzLabel]="workSetup.option" [nzValue]="workSetup"/>
         }
      </nz-select>
    </div>
    <div class="relocation-option">
      <h3 style="margin-top: 20px;">Are you open to relocating for this role?</h3>
      <div class="nz-block-input">
        <nz-select nzAllowClear nzPlaceHolder="Select your relocation preference" formControlName="relocation">
          @for (relocation of relocationOptions; track relocation; ) {
            <nz-option [nzLabel]="relocation" [nzValue]="relocation"/>
          }
        </nz-select>
      </div>
    </div>
  </div>

  <!-- Availability Card -->
  <div class="forms" [formGroup]="form">
    <h3>When are you available to start?</h3>
    <div class="nz-block-input" [ngClass]="{error: form.controls['availability'].status === 'INVALID' && form.controls['availability'].touched}">
      <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select availability" formControlName="availability">
         @for (workAvailability of availability; track workAvailability; ) {
        <nz-option [nzLabel]="workAvailability.option" [nzValue]="workAvailability"/>
         }
      </nz-select>
    </div>
  </div>

  <!-- Preferred Contact Card -->
  <div class="forms" [formGroup]="form">
    <h3>Best way to reach you <span class="optional-label">(optional)</span></h3>
    <div class="nz-block-input">
      <nz-select nzAllowClear nzMode="multiple" nzPlaceHolder="Select preferred contact" formControlName="preferredContact">
        @for (contact of contactOptions; track contact; ) {
          <nz-option [nzLabel]="contact"
            [nzValue]="contact"
            />
        }
      </nz-select>
    </div>
  </div>

</div>